// src/pages/Historico/utils/ordemAbas.js

// Mesmo valor de GraficoTipo.FREQUENCIA (infra/api/GraficoApi). Repetido aqui para este
// arquivo ficar puro: o GraficoApi carrega o axios, que o Jest do projeto não lê.
const FREQUENCIA = 'FREQUENCIA';

/** Abas na ordem do plano: com `frequenciaPrimeiro` (LEITE), Frequências abre a lista. */
export const abasNaOrdemDoPlano = (abas, { frequenciaPrimeiro = false } = {}) =>
    frequenciaPrimeiro
        ? [...abas.filter((t) => t.key === FREQUENCIA), ...abas.filter((t) => t.key !== FREQUENCIA)]
        : abas;
